module.exports = __webpack_public_path__ + "img/CM-SL-CA-Subaru-Modern.c8564566.jpg";